import { Injectable } from '@angular/core';
import { CanMatch, Route, Router } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ApiService } from 'src/app/core/services/api.service';
import { AuthSessionStore } from 'src/app/pages/login-v2/services/auth-session.store';
import { normalizeInternalAppRedirect } from '../utils/internal-app-redirect';

@Injectable({
  providedIn: 'root',
})
export class AutoLoginGuard implements CanMatch {
  constructor(
    private navCtrl: NavController,
    private api: ApiService,
    private router: Router,
    private authStore: AuthSessionStore,
  ) {}

  canMatch(route: Route): Observable<boolean> {
    if (this.authStore.pendingPostAuth()) {
      return of(true);
    }

    return this.api.isUser.pipe(
      //tap((res) => console.log(res)),
      filter((val) => val !== null),
      take(1),
      map((isAuthd) => {
        if (isAuthd) {
          this.navCtrl.setDirection('root');
          const redirect =
            route.path?.startsWith('pvz-link/') === true
              ? '/app/dashboard'
              : this.getRedirectUrl();
          this.router.navigateByUrl(redirect ?? '/app', { replaceUrl: true });
          return false;
        }
        return true;
      }),
    );
  }

  private getRedirectUrl(): string | null {
    const currentUrl =
      this.router.getCurrentNavigation()?.extractedUrl ??
      this.router.parseUrl(this.router.url);
    return normalizeInternalAppRedirect(
      currentUrl.queryParamMap.get('redirect'),
    );
  }
}
